import { URLS } from "@core/shared/utils";
import { platformFeaturesAtom } from "@framework/shared/atoms";
import { trans } from "@mongez/localization";
import { House, LayoutList } from "lucide-react";

export function useHomeNavigationLinks() {
  const platformFeatures = platformFeaturesAtom.useValue();

  return [
    {
      to: URLS.home,
      label: trans("home.title"),
      icon: House,
    },
    platformFeatures.socialFeed === true && {
      to: URLS.feed,
      label: trans("home.feed"),
      icon: LayoutList,
    },
  ].filter(Boolean) as Array<{
    to: string;
    label: string;
    icon: typeof House;
  }>;
}
